import useStateByServiceName from "helpers/getStateByServiceName";
import useEightLeggedFreakList from "hooks/useEightLeggedFreakList";
import useEightLeggedFreakNewsCriticsList from "hooks/useEightLeggedFreakNewsCriticsList";
import { useCallback } from "react";
const useLoadMoreButton = ({ serviceName, serviceType }) => {
    const { fetchMore: reviewsFetchMore, isUHD, loading: reviewsLoading } = useEightLeggedFreakList(serviceName);
    const { fetchMore: newsCriticsFetchMore, loading: newsCriticsLoading } = useEightLeggedFreakNewsCriticsList(serviceName);
    const { stateByServiceName } = useStateByServiceName(serviceName, serviceType);
    const onClick = useCallback(() => {
        if (serviceType === "news") {
            newsCriticsFetchMore({
                variables: {
                    eightLeggedFreakNewsSourcesListInput: {
                        cursor: stateByServiceName.nextCursor ?? undefined,
                        serviceName: serviceName
                    }
                }
            });
        }
        if (serviceType === "reviews") {
            reviewsFetchMore({
                variables: {
                    eightLeggedFreakListInput: {
                        cursor: stateByServiceName.nextCursor ?? undefined,
                        isUHD,
                        serviceName
                    }
                }
            });
        }
    }, [
        newsCriticsFetchMore,
        reviewsFetchMore,
        isUHD,
        serviceName,
        serviceType,
        stateByServiceName.nextCursor
    ]);
    return {
        isDisabled: !stateByServiceName.nextCursor || newsCriticsLoading || reviewsLoading,
        label: "Load More",
        loading: newsCriticsLoading || reviewsLoading,
        onClick
    };
};
export default useLoadMoreButton;
